import icon_user from "@/public/icon/user.svg"
import icon_addUser from "@/public/icon/add-user.svg"
import Icon from "@/components/etc/icon";
import React from "react";
import { useTranslations } from "next-intl";

type btnType = "login" | "signUp" | "mypage"
interface FloatBtnProps extends React.HTMLAttributes<HTMLDivElement> {
    type: btnType
}
const FloatBtn = React.forwardRef<HTMLDivElement, FloatBtnProps>(
    ({ type, ...rest }, ref) => {
        let text: string, icon: string;

        const t = useTranslations("Text")

        switch (type) {
            case "login":
                text = "로그인";
                icon = icon_user.src;
                break;
            case "signUp":
                text = "회원가입";
                icon = icon_addUser.src;
                break;
            case "mypage":
                text = "마이페이지";
                icon = icon_user.src;
                break;
        }
        return (
            <div className="fl-button" {...rest}>
                <Icon icon={undefined} src={icon} />
                <span>{t(text)}</span>
            </div>
        )
    }
)

export default FloatBtn;